// extracted by mini-css-extract-plugin
export var activeFilterButton = "_il-c";
export var backButton = "_il-4";
export var backIcon = "_il-5";
export var chevronShortcut = "_il-6";
export var container = "_il-1";
export var editor = "_il-8";
export var editorWrapper = "_il-7";
export var prefix = "_il-2";
export var searchIcon = "_il-3";
export var suffix = "_il-9";
export var suffixContent = "_il-a";
export var suffixText = "_il-b";
export var wrapper = "_il-0";